const fields = [
  {
    key: 'ordReemOtNro',
    label: 'N° orden',
    sortable: true
  },
  {
    key: 'ordReemTipOt',
    label: 'Tipo Servicio',
    sortable: true
  },
  {
    key: 'ordReemCliente',
    label: 'Rut Empresa',
    sortable: true
  },
  {
    key: 'ordReemFecha',
    label: 'Fecha ingreso',
    sortable: true
  },
  {
    key: 'ordReemMonto',
    label: 'Valor Servicio',
    sortable: true
  },
  {
    key: 'ordReemFecDoc',
    label: 'Fecha OT Reembolso',
    sortable: true
  },
  // {
  //   key: 'ordReemEstado',
  //   label: 'Estado',
  //   sortable: true
  // },
  {
    key: 'ordReemUsuario',
    label: 'Responsable',
    sortable: true
  },
  {
    key: 'ordReemFecDig',
    label: 'Fecha ingreso a pago',
    sortable: true
  },
  {
    key: 'ordReemAsigCargo',
    label: 'N° Asignación',
    sortable: true
  },
  {
    key: 'ordReemPatente',
    label: 'Patente',
    sortable: true
  },
  // {
  //   key: 'ciudad',
  //   label: 'Ciudad',
  //   sortable: true
  // },
  {
    key: 'sucursal',
    label: 'Sucursal',
    sortable: true
  }
];
const fieldsRAC = [
  {
    key: 'item',
    label: 'Ítem'
  },
  {
    key: 'contrato',
    label: 'Nro. Contrato'
  },
  {
    key: 'reserva',
    label: 'Nro. Reserva'
  },
  {
    key: 'monto',
    label: 'Monto'
  },
  {
    key: 'doc',
    label: 'Descargar'
  }
];
module.exports = {
  fields,
  fieldsRAC
}
